import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { getPlantData } from "../../store/design/actions"
import ReactApexChart from "react-apexcharts"
import { getAreas, updateArea, deleteArea, addArea} from "../../store/goals/actions"
import moment from 'moment';
import classnames from "classnames"
import { connect } from "react-redux"
import { v4 as uuidv4 } from 'uuid';
import Spreadsheet from "react-spreadsheet";

import {
  Badge,
  Col,
  Collapse,
  CardHeader,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Container,
  Dropdown,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
  TabContent,
  TabPane,
  Input,
} from "reactstrap"
import { withRouter, Link } from "react-router-dom"
import { map } from "lodash"

import { StorageImage } from '@aws-amplify/ui-react-storage';

import { Storage } from '@aws-amplify/storage'
import { Image } from '@aws-amplify/ui-react'


const Observe = props => {
const { plantData, plantMap, guildResults, customplants, userareas, onAddArea, onGetCustomPlants, onSearchGuild, onDeleteArea, onDeleteCustomPlant, onUpdateArea, onUpdateCustomPlant, onSaveCustomPlant } = props
const [currHarvests, setCurrHarvests] = useState([])
const [singlebtn, setSinglebtn] = useState(false)
const [expandMenu, setExpandMenu] = useState(false)
const [plantModal, setPlantModal] = useState(false)
const [addPlantModal, setAddPlantModal] = useState(false)
const [addAreaModal, setAddAreaModal] = useState(false)
const [copyCustomPlantModal, setCopyCustomPlantModal] = useState(false)
const [customPlant, setCustomPlant] = useState()
const [currPlant, setCurrPlant] = useState({})
const [currYear, setCurrYear] = useState(new Date().getFullYear())
const [space, setTotalSpace] = useState()
const [name, setName] = useState()
const [variety, setVariety] = useState()
const [numPlants, setNumPlants] = useState()
const [editAreaModal, setEditAreaModal] = useState(false)
const [addTaskModal, setAddTaskModal] = useState(false)
const [activeTab, setActiveTab] = useState("1")
const [editTaskModal, setEditTaskModal] = useState(false)
const [isPlantEdit, setPlantEdit] = useState(false)
const [plantInfo, setPlantInfo] = useState(false)
const [plantDates, setPlantDates] = useState(false)
const [plantHarvests, setPlantHarvests] = useState(false)
const [plantNotes, setPlantNotes] = useState(false)
const [customPlantEdit, setCustomPlantEdit] = useState(false)
const [currArea, setCurrArea] = useState({plants:[]})
const [currGoal, setCurrGoal] = useState({})
const [currTask, setCurrTask] = useState({})
const [species, setSpecies] = useState()
const [showHarvests, setShowHarvests] = useState(false)
const [spreadsheetArea, setSpreadsheetArea] = useState()
const [taskType, setTaskType] = useState()
const [taskArea, setTaskArea] = useState()
const [taskPlants, setTaskPlants] = useState([])
const [taskObjective, setTaskObjective] = useState()
const [taskStatus, setTaskStatus] = useState()
const [taskEndDate, setTaskEndDate] = useState()
const [areas, setAreas] = useState([])
const [copyArea, setCopyArea] = useState()
const [daysToHarvest, setDaysToHarvest] = useState()
const [harvestAmount, setHarvestAmount] = useState()
const [harvestDate, setHarvestDate] = useState()
const [harvestUnit, setHarvestUnit] = useState()
const [summer, setSummer] = useState(Array(20).fill(false))
const [spring, setSpring] = useState(Array(20).fill(false))
const [fall, setFall] = useState(Array(20).fill(false))
const [winter, setWinter] = useState(Array(20).fill(false))
const [seedStartDate, setSeedStartDate] = useState()
const [actualSeedStartDate, setActualSeedStartDate] = useState()
const [transplantDate, setTransplantDate] = useState()
const [text, setText] = useState("")
const [timelineData, setTimelineData] = useState([])
const [plantIndex, setPlantIndex] = useState()
const [areaIndex, setAreaIndex] = useState()
const [spreadsheetView, setSpreadsheetView] = useState(false)
const [normalView, setNormalView] = useState(true)
const [customPlantsView, setCustomPlantsView] = useState(false)
const [areaOptions, setAreaOptions] = useState(Array(20).fill(false))
const [areaExpand, setAreaExpand] = useState(Array(20).fill(false))
const [goalExpand, setGoalExpand] = useState(Array(20).fill(false))
const [plantOptions, setPlantOptions] = useState([])
const [harvestPlotOptions, setHarvestPlotOptions] = useState({})
const [plantStatus, setPlantStatus] = useState ()
const [measurementScale, setMeasurementScale] = useState ("E")
const [tableData, setTableData] = useState([])
const [plantMappings, setPlantMappings] = useState({})
const [selectedCell, setSelectedCell] = useState()

const username = JSON.parse(localStorage.getItem("user")).user


function addArea () {
   
}


const foobar = "200px";

const saveProject = () => {
  // placehold for saving a project
}

const handleSelect = e => {
console.log(e);
}

return (
<React.Fragment>
<div className="page-content">
<Container fluid>
<Row>
  <Col md={12}>
	 <Card style={{backgroundColor:"#738276"}} className="text-white-50">
                <CardBody>
                  <CardTitle className="mb-4 text-white">
                    <i class="bx bx-happy-beaming"></i> Welcome to SAGE! 
                  </CardTitle>
                  <CardText>
                      You are on your way to setting up your garden for successful harvests and abundance.  Since this is the first time that you've logged into SAGE, we need to set up some information about your property and garden to help SAGE find your nearest weather station and terrain information. 
                  </CardText>
                </CardBody>
              </Card>

   </Col>
 </Row>

        </Container>
      </div>
    </React.Fragment>
  )
}

Observe.propTypes = {
  resources: PropTypes.array,
}

const mapStateToProps = (state, ownProps) => { 
  return {
  userareas: state.goals.areas
  }
}

const mapDispatchToProps = dispatch => ({
  onUpdateArea: area => dispatch(updateArea(area)),
  onAddArea: area => dispatch(addArea(area)),
  onDeleteArea: id => dispatch(deleteArea(id)),
  onGetAreas: () => dispatch(getAreas()), 
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Observe))
